/**
 * Intercompany funding (FSD 3.2.1 / 3.2.3; FIN-T01-R032, V074, V075, V106,
 * AC058, AC059, AC090; report "Intercompany Loan Register").
 *
 * One screen, two tabs: the instrument register (every loan, advance and
 * current-account agreement between two legal entities, with its lifecycle) and
 * the loan register report. Gated on `cash.ic_instrument.read`, which every GET
 * route of the feature declares; each write is further gated on
 * `cash.ic_instrument.manage`.
 *
 * The wiring packet spreads `TREASURY_INTERCOMPANY_ROUTES` beside
 * `TREASURY_ROUTES` and adds the `treasury-intercompany-instruments` nav item.
 */

import type { RouteRecordRaw } from 'vue-router'

import { IC_INSTRUMENT_PERMISSIONS } from '@/modules/treasury/intercompany/permissions'

export const TREASURY_INTERCOMPANY_PATH = '/treasury/intercompany-instruments'

export const IC_INSTRUMENT_PATHS = {
  register: TREASURY_INTERCOMPANY_PATH,
  /** The register with one instrument opened in the detail panel. */
  instrument: (id: number) => `${TREASURY_INTERCOMPANY_PATH}?instrument=${id}`,
  loanRegister: `${TREASURY_INTERCOMPANY_PATH}?tab=loans`,
} as const

export const TREASURY_INTERCOMPANY_ROUTES: RouteRecordRaw[] = [
  {
    path: TREASURY_INTERCOMPANY_PATH,
    name: 'treasury-intercompany-instruments',
    component: () => import('@/modules/treasury/intercompany/IntercompanyInstrumentsView.vue'),
    meta: {
      titleKey: 'treasury.routeTitles.intercompanyInstruments',
      permission: IC_INSTRUMENT_PERMISSIONS.read,
    },
  },
]
